var map = {
	"./paradise/dedinky/i18n.json": 3497,
	"./paradise/dobsinskaladova/i18n.json": 4904,
	"./paradise/klastorisko/i18n.json": 465,
	"./paradise/malykyselferata/i18n.json": 6535,
	"./paradise/piecky/i18n.json": 3590,
	"./paradise/prielomhornadu/i18n.json": 8966,
	"./paradise/ranc_podlesok/i18n.json": 2611,
	"./paradise/suchabela/i18n.json": 8803,
	"./paradise/tomasovskyvyhlad/i18n.json": 2409,
	"./paradise/zemjarskadolina/i18n.json": 5892,
	"./poprad/christiania/i18n.json": 4961,
	"./poprad/espressobar/i18n.json": 1113,
	"./poprad/forum/i18n.json": 9589,
	"./poprad/kvetnica/i18n.json": 1047,
	"./poprad/mamut/i18n.json": 9982,
	"./poprad/max/i18n.json": 7572,
	"./poprad/sintra/i18n.json": 5838,
	"./poprad/tatranskagaleria/i18n.json": 7024,
	"./poprad/tatras/i18n.json": 843,
	"./poprad/tonetka/i18n.json": 2614,
	"./poprad/useptima/i18n.json": 9420,
	"./poprad/utopia/i18n.json": 9912,
	"./poprad/zamcisko/i18n.json": 1541,
	"./tatra/belianskajaskyna/i18n.json": 6773,
	"./tatra/cukrarentatra/i18n.json": 5041,
	"./tatra/gerlachovskystit/i18n.json": 568,
	"./tatra/hrebienok/i18n.json": 1159,
	"./tatra/lomnickystit/i18n.json": 4326,
	"./tatra/rysy/i18n.json": 6193,
	"./tatra/skalnatepleso/i18n.json": 9666,
	"./tatra/teryhochata/i18n.json": 3964,
	"./tatra/zbojnickachata/i18n.json": 5128
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8618;